(function() {
  'use strict';

  angular.module('component.announcements')
    .component('announcementsReorder', {
      templateUrl: 'app/components/announcements/list-reorder.html',
      controller: 'AnnouncementsReorderController',
      controllerAs: 'announcementsReorderCtrl'
    });
})();
